module.exports = __webpack_public_path__ + "img/nav_study_selected.57cfd3e8.svg";